/**
 * 品格商城通用函数模块.
 */

var model = {
  // 获取成果类型名称
  GetResultTypeName(val) {
    switch (val) {
      case 1:
        return '北京市中国特色社会主义理论体系研究中心立项课题'
      case 2:
        return '北京市中国特色社会主义理论体系研究中心举办学术活动'
      case 3:
        return '北京市中国特色社会主义理论体系研究中心发表理论文章'
      case 4:
      return '北京市中国特色社会主义理论体系研究中心刊发理论专版'
      case 5:
      return '北京市中国特色社会主义理论体系研究中心出版学术专著'
      case 6:
      return '当代北京史系列图书'
      case 7:
      return '北京市社科联决策咨询课题'
      default:
        return ''
    }
  },
  
  // 获取基金类型
  GetFundTypeName(val) {
    switch (val) {
      case 1:
        return '常规资助书目'
        case 2:
        return '重点资助书目'
      default:
        return ''
    }
  },
  // 获取评奖类型
  GetAwardTypeName(val) {
    switch (val) {
      case 1:
        return '申报成果'
        case 2:
        return '获奖成果'
      default:
        return ''
    }
  },
  // 获取成果属性
  GetAwardProperty(val) {
    switch (val) {
      case 1:
        return '专著'
      case 2:
        return '论文'
        case 3:
        return '工具书'
        case 4:
        return '科研工具'
        case 5:
        return '调研报告'
        case 6:
        return '教材'
        case 7:
        return '古籍整理'
        case 8:
        return '史料专著'
        case 9:
        return '名著选'
        case 10:
        return '普及读物'
      default:
        return ''
    }
  },
  // 获取成果形式
  GetResultFormat(val) {
    switch (val) {
      case 1:
        return '调研报告'
      case 2:
        return '论文'
        case 3:
        return '专著'
        case 4:
        return '三级提纲'
        case 5:
        return '报告'
        case 6:
        return '文章'
      default:
        return ''
    }
  }
}
export default model



// WEBPACK FOOTER //
// ./src/utils/utils.js